import { timeline } from '../data/portfolioData';

export const Timeline = ({ isVisible }) => (
  <section id="experience" className={`timeline ${isVisible ? 'fade-in' : ''}`}>
    <div className="sec-head">
      <span className="kicker">◆ 04 · HISTORY LOG</span>
      <h2>The path <em>so far</em>.</h2>
    </div>

    <ol className="tl-list">
      {timeline.map((item, i) => (
        <li key={i} className="tl-item" style={{ '--tl-color': item.color }}>
          <div className="tl-date">
            {item.date.split('\n').map((line, j) => (
              <span key={j}>{line}{j < item.date.split('\n').length - 1 && <br />}</span>
            ))}
          </div>
          <div className="tl-card">
            <div className="tl-role">{item.role}</div>
            <div className="tl-co">{item.company}</div>
            <ul>
              {item.items.map((li) => <li key={li}>{li}</li>)}
            </ul>
            <div className="tl-tags">
              {item.tags.map((tag) => <span key={tag}>{tag}</span>)}
            </div>
          </div>
        </li>
      ))}
    </ol>
  </section>
);
